'use client';

import { ReactNode } from 'react';
import MobileLayout from '@/components/layout/Mobile';
import { TransitionProvider } from '@/components/Mobile/Transition/TransitionContext.jsx';
import SwipeTransition from '@/components/Mobile/Transition/SwipeTransition';

export function MobileShell({ children }: { children: ReactNode }) {
  return (
    <TransitionProvider>
      <MobileLayout>
        <SwipeTransition>{children}</SwipeTransition>
      </MobileLayout>
    </TransitionProvider>
  );
}
